import React from "react";
import "./CloseButton.css";

export default props => (
  <button className="CloseButton" {...props}>
    &times;
  </button>
);



// WEBPACK FOOTER //
// ./src/components/CloseButton/CloseButton.js